import qs from "qs";

import { EntityAttribute } from "shared/api/api";
import { SchemaDefinition } from "shared/api/schemaDefinitions/types";
import { getSidebarSchemas } from "shared/api/schemaDefinitions/utils";

import {
  filterStateToFilterGroupState,
  getFiltersQuery,
} from "features/ui/Filters/FilterBuilder/utils";
import { FilterOperator } from "features/ui/Filters/types";
import { getFiltersKey } from "features/ui/Filters/utils";

import { routes } from "services/routes";

import { SchemaSearch, SearchResource } from "./types";

export const replaceUrlParams = (urlTemplate: string, key: string) =>
  urlTemplate.replace(/:([a-zA-Z]+)/, key);

export const createLinkForResultItem = (
  config: SearchResource,
  itemId: string
) => {
  if (config.isRouteList && config.routeFilterKey && config.listingFieldId) {
    const key = getFiltersKey(config.routeFilterKey);
    const queryParams = {
      [key]: getFiltersQuery(
        filterStateToFilterGroupState({
          [config.listingFieldId]: {
            values: [itemId],
            operator: FilterOperator.IN,
          },
        })
      ),
    };

    // Using qs.stringify with arrayFormat: "indices" to match the app's URL format
    return {
      pathname: routes[config.routeKey],
      search: `?${qs.stringify(queryParams, { arrayFormat: "indices" })}`,
    };
  }

  return {
    pathname: replaceUrlParams(routes[config.routeKey], itemId),
  };
};

export const getPrimarySearchAttribute = (
  attributes: EntityAttribute[] = []
) =>
  attributes?.find((attribute) => attribute.ID === "externalID")
    ? "externalID"
    : "ID";

export const splitSchemaSearchesBySidebar = (
  allSchemas: SchemaDefinition[],
  schemaSearches: SchemaSearch[]
) => {
  const sidebarSchemas = getSidebarSchemas(allSchemas);

  return {
    inSidebar: sidebarSchemas.flatMap(
      ({ ID }) =>
        schemaSearches.find(({ schema }) => schema.ID === ID)?.search ?? []
    ),
    notInSidebar: schemaSearches
      .filter(
        ({ schema }) => !sidebarSchemas.some(({ ID }) => ID === schema.ID)
      )
      .map(({ search }) => search),
  };
};
